export enum Cryptocurrency {
  ETH = 'ETH',
  BTC = 'BTC',
  LTC = 'LTC',
  BCH = 'BCH',
}
